<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
            class="orange">【预约管理】</span>
        </p>
        <img src="../../../assets/img/docAppointRes_a.png" alt="">
        <p><strong>第二步：</strong>在【预约管理】页面中，找到要进行咨询的预约条目，点击<span class="orange">【前往通话】</span>按钮，进入通话页面
        </p>
        <img src="../../../assets/img/docAppointRes_b.png" alt="">
        <p><strong>第三步：</strong>在【通话】页面，点击<span class="orange">【拨号】</span>图标，即可呼叫用户，如用户未就绪，请耐心等待片刻
        </p>
        <img src="../../../assets/img/docAppointRes_c.png" alt="">
        <p><strong>咨询设备设置：</strong>开启视频需要浏览器获取设备权限, 当提示【是否允许获取麦克风、摄像头权限】时,请选择【允许】， 如【拒绝】将无法正常使用视频、语音等功能</p>
        <img src="../../../assets/doctorImg/consultation_a.png" alt="">
        <p>如未显示，需重置麦克风、摄像头权限。以Chrome为例，设置步骤如下</p>
        <p><strong>第一步：</strong>在【Chrome】浏览器中，找到【设置】</p>
        <img src="../../../assets/doctorImg/consultation_b.png" alt="" height="355">
        <p><strong>第二步：</strong>在【设置】页面，选中左边菜单栏中的<span class="orange">【隐私设置和安全性】</span>，点击<span
            class="orange">【网站设置】</span></p>
        <p>近期活动中如有域名 <span class="orange">www.neuropsychstudio.com</span>，打开后点击【重置权限】</p>
        <img src="../../../assets/doctorImg/consultation_c.png" alt="" height="226">
        <img src="../../../assets/doctorImg/consultation_d.png" alt="">
        <img src="../../../assets/doctorImg/consultation_e.png" alt="">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>登录状态下，在【首页】，点击右上角<span class="orange">【≡】</span>按钮，从右侧弹出菜单弹窗</p>
          <p><strong>第二步：</strong>在【菜单栏】中点击<span class="orange">【预约管理】</span>进入【预约列表】</p>
          <p><strong>第三步：</strong>在【预约列表】中，选择即将咨询的预约条目，并点击<span class="orange">【前往通话】</span>按钮</p>
        </div>
        <img src="../../../assets/img/docAppointRes_d.png" alt="">
        <div class="flex userPh">
          <p><strong>第四步：</strong>使用【微信APP】，识别<span class="orange">【心理亦笙】</span>小程序二维码</p>
          <p><strong>第五步：</strong>进入【亦笙工作室】微信小程序中，填写登录信息，点击<span class="orange">【登录】</span>按钮</p>
          <p><strong>第六步：</strong>在【待通话列表】中，点击<span class="orange">【通话】</span>按钮，进入通话页面</p>
        </div>
        <img src="../../../assets/img/docAppointRes_e.png" alt="">
        <div class="flex userPh">
          <div><strong>第七步：</strong>在【通话页面】中，点击<span class="orange">【拨号】</span>图标<strong
              class="userPh">【通话状态】</strong></div>
        </div>
        <div class="flex">
          <img src="../../../assets/img/docAppointRes_f.png" alt="" width="67%">
          <div class="mt_50 mr_20">
            <div class="mt_20">【视频通话】<br/>进入咨询等待页面后，请耐心等待用户的应答</div>
            <div class="mt_20">【文字聊天】<br/>视频下方有文字聊天框，可发送图片，协助咨询交流</div>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "appoint",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
